<script>
export default {
    data() {
        return {
            event: null,
            showModal: false,
        };
    },
    methods: {
        openModal(event) {
            this.event = event;
            this.showModal = true;
        },
        deleteReminder(reminder) {
            const self = this;
            axios.delete(`/api/tasks/${reminder.id}`).then(() => {
                self.showModal = false;
                Bus.$emit('allCalendarsRefetch');
            });
        },
    },
    computed: {
        scheduleDate() {
            return this.$store.getters['calendars/getScheduleDate']({
                calendar: 'fullCalendar',
                date: this.event.start,
            });
        },
    },
};
</script>
